import styled from "styled-components";
import { Currency } from "../../../types/Currency/Currency";
import { PricingRule } from "../../../types/PricingRule/PricingRule";
import Price from "../../../@ui/Price";
import { LicenceTypePurchase } from "../../../types/Licences/LicenceTypePurchase";
import { useCurrencyContext } from "../../../context/Currency/CurrencyContext";

interface ConcurrentPricingProps {
  licence: LicenceTypePurchase;
}

const ConcurrentPricing = ({
  licence: { pricingRules, expiryDays },
}: ConcurrentPricingProps) => {
  const { selectedCurrency } = useCurrencyContext();

  const prs = pricingRules ?? [];

  return (
    <>
      {prs
        .sort((a, b) => a.minRange! - b.minRange!)
        .map((pricingRule, index) => (
          <p key={index}>
            <Price
              price={pricingRule.transactionCostIncTax}
              currencyCode={selectedCurrency!.code}
            />{" "}
            per user for {pricingRule.minRange}
            {pricingRule.maxRange == null
              ? " or more users"
              : ` to ${pricingRule.maxRange} users`}
          </p>
        ))}
      <p>Expires after {expiryDays} days</p>
    </>
  );
};

export default ConcurrentPricing;
